<template>
  <div class="question">
    <!-- <div class="mainTitle">试题管理</div> -->

    <!-- <el-card > -->
    <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
      <el-row :gutter="20">
        <el-col
          v-if="!$route.query.chapterId || !$route.query.examId"
          :sm="24"
          :md="12"
          :lg="5"
        >
          <el-form-item prop="courseId">
            <!-- <el-cascader
                clearable
                :show-all-levels="false"
                :props="subjectTreeProps"
                ref="selectionTree"
                placeholder="请输入课程"
                :options="subjectTreeList"
                @change="subjectChange"
              ></el-cascader>-->
            <el-cascader
              v-model="searchForm.courseId"
              :show-all-levels="false"
              ref="tree"
              placeholder="请选择课程"
              @change="subjectChange"
              :options="subjectTreeList"
              :props="subjectTreeProps"
              clearable
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="5">
          <el-form-item prop="questionTypeId">
            <el-cascader
              :show-all-levels="false"
              ref="tree"
              placeholder="请选择章节"
              :disabled="ChapterTree.length > 0 ? false : true"
              @change="chapterIdChange"
              :options="ChapterTree"
              :props="subjectTreeProps"
              clearable
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="5">
          <el-form-item prop="questionTypeId">
            <el-select
              :disabled="ExamTree.length > 0 ? false : true"
              clearable
              v-model="searchForm.examId"
              placeholder="请输入试卷"
            >
              <el-option
                v-for="item in ExamTree"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="5">
          <el-form-item prop="questionTypeId">
            <el-select
              :disabled="KnowledgeTree.length > 0 ? false : true"
              filterable
              clearable
              v-model="searchForm.knowledgeId"
              placeholder="请选择考点"
            >
              <el-option
                v-for="item in KnowledgeTree"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="4">
          <el-form-item prop="title">
            <el-input
              clearable
              v-model="searchForm.title"
              placeholder="请输入题干"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="24" :md="12" :lg="5">
          <el-form-item prop="questionTypeId">
            <el-select
              clearable
              v-model="searchForm.questionTypeId"
              placeholder="请输入题型"
            >
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          v-if="!$route.query.chapterId || !$route.query.examId"
          :sm="24"
          :md="12"
          :lg="5"
        >
          <el-form-item prop="state">
            <!-- <el-radio-group v-model="searchForm.state">
                <el-radio :label="1">上架</el-radio>
                <el-radio :label="-1">下架</el-radio>
              </el-radio-group>-->
            <el-select
              clearable
              v-model="searchForm.state"
              placeholder="选择上下架"
            >
              <el-option
                v-for="item in stateList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="24" :md="12" :lg="5">
          <el-form-item prop="title">
            <el-input
              clearable
              v-model="searchForm.remark"
              placeholder="备注"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col style="float: right" :sm="24" :md="12" :lg="8">
          <div class="button-Array" style="float: right">
            <!-- <el-button
                type="primary"
                @click="reset"
                icon="el-icon-refresh"
              >重置</el-button>-->
            <!-- <a class="mainColor" @click="reset">清空</a> -->
            <el-button
              type="primary"
              style="
                border-top-right-radius: 0px;
                border-bottom-right-radius: 0px;
              "
              @click="pageList(1)"
              icon="el-icon-search"
              >搜索</el-button
            >
            <el-button
              style="border-radius: 0px"
              type="primary"
              @click="reset"
              icon="el-icon-refresh"
              >重置</el-button
            >
            <el-button
              style="border-radius: 0px"
              type="primary"
              @click="$emit('sentMsg', multipleSelection)"
              icon="el-icon-refresh"
              >添加({{ multipleSelection.length }})</el-button
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- </el-card> -->
    <!-- 每小题备选答案中，只有一个符合题意的正确答案。多选、错选、不选均不得分 -->
    <div class="box-card" style="margin-top: 20px">
      <el-table
        ref="multipleTable"
        :data="page.rows"
        style="width: 100%; margin-top: 0px"
        row-key="id"
        border
        @sort-change="sortChange"
        v-loading="webLoading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        @selection-change="selectionChange"
      >
        <el-table-column
          type="selection"
          width="40"
          :selectable="checkSortable"
        ></el-table-column>

        <el-table-column
          prop="big"
          label="类型"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.big == 1">大题</span>
            <span v-else-if="scope.row.big == -1 && scope.row.pid.length == 1"
              >常规试题</span
            >
            <span v-else>小题</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="courseName"
          label="课程"
          width="160"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column prop="title" show-overflow-tooltip label="题干">
          <template slot-scope="scope">
            <div class="message">
              <div class="state">
                <span
                  v-if="scope.row.state == 1"
                  style="background: rgb(24, 200, 168)"
                  >上架</span
                >
                <span v-else style="background: rgba(231, 76, 60, 1)"
                  >下架</span
                >
              </div>
              <div class="questionTypeName" v-if="scope.row.big != 1">
                <span style="background: #409eff">{{
                  scope.row.questionTypeName
                }}</span>
              </div>
              <div
                class="htmltittle"
                @click="getInfoById(scope.row.id)"
                v-html="scope.row.title"
              ></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="answer"
          label="答案"
          align="center"
          width="60"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.big != 1">{{ scope.row.answer || '-' }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
      </el-table>-->
      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    courseId: ""
  },
  data () {
    return {
      stateList: [
        { name: "上架", id: 1 },
        { name: "下架", id: -1 }
      ],
      nameArray: [],
      ChapterTree: [],
      ExamTree: [],
      KnowledgeTree: [],
      webLoading: false,
      topData: [
        {
          lable: "近3月做题总量",
          value: "134762"
        },
        {
          lable: "近3月答对数量",
          value: "25,538"
        },
        {
          lable: "近3月答错数量",
          value: "25,538"
        }
      ],
      viewDetial: false, //查看明细
      viewLog: false, //做题记录
      logData: [], //做题记录
      viewForm: [], //查看
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      addFormVisible: false,
      editFormVisible: false,
      addFormVisible1: false,
      importFormVisible: false,
      searchForm: {
        courseId: "",
        title: "",
        questionTypeId: "",
        examId: "",
        chapterId: "",
        knowledgeId: "",
        orderBy: "asc",
        state: null,
        remark: '',
      },
      addForm: {
        courseId: "",
        state: null,
        questionTypeId: "",
        hard: "",
        title: "",
        answer: "",
        analysis: "",
        videoPath: ""
      },
      addFormRules: {
        courseId: [
          {
            required: true,
            message: "请输入所属科目",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "所属科目格式不正确"
          }
        ],
        questionTypeId: [
          {
            required: true,
            message: "请输入试题题型",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "试题题型格式不正确"
          }
        ],
        state: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "格式不正确"
          }
        ],
        hard: [
          {
            required: true,
            message: "请输入难度系数 1-5",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "难度系数 1-5格式不正确"
          }
        ],
        title: [
          {
            required: true,
            message: "请输入标题题干",
            trigger: "blur"
          },
          {
            min: 1,
            max: 4000,
            message: "标题题干长度在1到4000个字"
          }
        ],
        answer: [
          {
            required: true,
            message: "请输入试题答案",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "试题答案长度在1到255个字"
          }
        ],
        analysis: [
          {
            required: true,
            message: "请输入试题解析",
            trigger: "blur"
          },
          {
            min: 1,
            max: 4000,
            message: "试题解析长度在1到4000个字"
          }
        ],
        videoPath: [
          {
            required: true,
            message: "请输入视频地址",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "视频地址长度在1到255个字"
          }
        ]
      },
      editForm: {
        courseId: "",
        questionTypeId: "",
        state: null,
        hard: "",
        title: "",
        answer: "",
        analysis: "",
        videoPath: ""
      },
      editFormRules: {
        courseId: [
          {
            required: true,
            message: "请输入所属科目",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "所属科目格式不正确"
          }
        ],
        questionTypeId: [
          {
            required: true,
            message: "请输入试题题型",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "试题题型格式不正确"
          }
        ],
        state: [
          {
            required: true,
            message: "请输入",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "格式不正确"
          }
        ],
        hard: [
          {
            required: true,
            message: "请输入难度系数 1-5",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "难度系数 1-5格式不正确"
          }
        ],
        title: [
          {
            required: true,
            message: "请输入标题题干",
            trigger: "blur"
          },
          {
            min: 1,
            max: 4000,
            message: "标题题干长度在1到4000个字"
          }
        ],
        answer: [
          {
            required: true,
            message: "请输入试题答案",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "试题答案长度在1到255个字"
          }
        ],
        analysis: [
          {
            required: true,
            message: "请输入试题解析",
            trigger: "blur"
          },
          {
            min: 1,
            max: 4000,
            message: "试题解析长度在1到4000个字"
          }
        ],
        videoPath: [
          {
            required: true,
            message: "请输入视频地址",
            trigger: "blur"
          },
          {
            min: 1,
            max: 255,
            message: "视频地址长度在1到255个字"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "0px",
      selection: "",
      multipleSelection: [],
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },

      subjectTreeList: [], //科目
      selectedVal_: "", //科目
      typeList: [], //试题题型
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      // multiple: true 下拉多选

      loading: false
    };
  },
  methods: {
    checkboxT (row, rowIndex) {
      // console.log(row,'checkt')
      // if (rowIndex == 0) {
      //   //      if(row.lie =='1'){
      //   return false;//禁用
      // } else {
      //   return true;//不禁用
      // }
    },
    showmessahe (data) {
      this.importFormVisible = data;
      this.pageList();
    },
    handleCommand2 (command) {
      let aaa = command.split("@");
      if (aaa[0] == "getInfoById") {
        this.getInfoById(aaa[1]);
      }
    },
    // 获取试题信息
    getInfoById (id) {
      this.api.question.getInfoById({ id: id }).then(result => {
        if (result.success) {
          this.viewForm = result.data;
          this.viewDetial = true;
        } else {
          this.$message.error(result.message);
        }
      });
    },
    goAddCpQuestion (row, style) {
      if (style == 1) {
        this.$router.push({
          path: "/addCpQuestion",
          query: {
            upId: row.id,
            chapterId: this.$route.query.chapterId || "",
            examId: this.$route.query.examId || ""
          }
        });
      } else {
        this.$router.push({
          path: "/addQuestion",
          query: {
            upId: row.id,
            upPid: row.pid,
            chapterId: this.$route.query.chapterId || "",
            examId: this.$route.query.examId || ""
          }
        });
      }
    },
    handleSelectionChange (val) { },
    // 添加试题
    goAddQusetion (id) {
      this.$router.push({
        path: "/addQuestion",
        query: {
          id: id
        }
      });
    },
    getSubjectTreeList () {
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });

      // 获取试题类型
      this.api.question
        .questionTypeList()
        .then(result => {
          this.typeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTree () {
      this.api.chapter
        .getChapterSelectListByCourse({ courseId: this.searchForm.courseId })
        .then(result => {
          this.ChapterTree = result.data;
        })
        .catch(error => {
          console.log(error);
        });
      this.api.exam
        .getExamSelectListByCourse({ courseId: this.searchForm.courseId })
        .then(result => {
          this.ExamTree = result.data;
        })
        .catch(error => {
          console.log(error);
        });
      this.api.chapter
        .getKnowledgeSelectListByCourse({
          courseId: this.searchForm.courseId,
          keyword: ""
        })
        .then(result => {
          this.KnowledgeTree = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    chapterIdChange (val) {
      this.searchForm.chapterId = val[val.length - 1];
    },
    subjectChange (val) {
      this.searchForm.examId = "";
      this.searchForm.chapterId = "";
      this.searchForm.knowledgeId = "";
      this.searchForm.courseId = val[2];
      // this.searchForm.courseIds = [];
      // val.forEach(item => {
      //   this.searchForm.courseIds.push(item[2]);
      // });

      // let arr = [];
      // let nameArr = [];
      // if (val.children) {
      //   val.children.forEach((item, index) => {
      //     if (item.children) {
      //       item.children.forEach((items, indexs) => {
      //         if (items.children) {
      //           items.children.forEach((itemss, indexss) => {
      //             if (itemss.children) {
      //               itemss.children;
      //             } else {
      //               arr.push(itemss.id);
      //               nameArr.push(itemss.name);
      //             }
      //           });
      //         } else {
      //           arr.push(items.id);
      //           nameArr.push(items.name);
      //         }
      //       });
      //     } else {
      //       arr.push(item.id);
      //       nameArr.push(item.name);
      //     }
      //   });
      // } else {
      //   arr.push(val.id);
      //   nameArr.push(val.name);
      // }
      // arr.forEach(item => {
      //   let sty = true;

      //   let index = null;
      //   this.searchForm.courseIds.forEach((items, indexs) => {
      //     if (items == item) {
      //       sty = false;
      //       index = indexs;
      //     }
      //   });
      //   if (sty) {
      //     this.searchForm.courseIds.push(item);
      //   } else {
      //     this.searchForm.courseIds.splice(index, 1);
      //   }
      // });
      // nameArr.forEach(item => {
      //   let sty = true;
      //   let index = null;
      //   this.nameArray.forEach((items, indexs) => {
      //     if (items == item) {
      //       sty = false;
      //       index = indexs;
      //     }
      //   });
      //   if (sty) {
      //     this.nameArray.push(item);
      //   } else {
      //     this.nameArray.splice(index, 1);
      //   }
      // });
      // this.selectedVal_ = "";
      // this.nameArray.forEach(item => {
      //   if (this.selectedVal_) {
      //     this.selectedVal_ = this.selectedVal_ + "," + item;
      //   } else {
      //     this.selectedVal_ = item;
      //   }
      // });
      // // console.log("arr", arr);
      // console.log("this.selectedVal_", this.selectedVal_);
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    checkSortable (row) {
      if (row.big == 1 || row.big == -1 && row.pid.length == 1) {
        return true
      } else {
        return false
      }
      console.log(row, 99999999)
    },
    selectionChange (val) {
      let arr = [];
      this.multipleSelection = val;
      val.map(e => arr.push(e.id));
      this.ids = arr;
    },
    goQuestion (command) {
      if (this.$route.query.chapterId) {
        this.$router.push({
          path: command,
          query: {
            chapterId: this.$route.query.chapterId
          }
        });
      } else if (this.$route.query.examId) {
        this.$router.push({
          path: command,
          query: {
            examId: this.$route.query.examId
          }
        });
      } else {
        this.$router.push({
          path: command
        });
      }
    },
    sortChange (column, prop, order) {
      if (column.order == "ascending") {
        this.searchForm.orderBy = "asc";
      } else if (column.order == "descending") {
        this.searchForm.orderBy = "desc";
      }
      this.pageList();
    },
    getQuestion () {
      this.api.question
        .getQuestion({
          id: this.selection
        })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList () {
      this.webLoading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      // this.searchForm.chapterId = this.$route.query.chapterId || "";
      // this.searchForm.examId = this.$route.query.examId || "";
      this.api.question
        .pageList(this.searchForm)
        .then(result => {
          this.webLoading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          // this.checkSortable()
        })
        .catch(error => {
          console.log(error);
        });
    },
    addQuestion () {
      this.addForm.title = this.$refs.myQuillEditor._data.content;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.question
            .addQuestion(this.addForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.addFormVisible = false;
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateQuestion () {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.question
            .updateQuestion(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteQuestion (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          this.api.question
            .deleteQuestion({
              id: row.id
            })
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => { });
    },
    batchDeleteQuestion () {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning"
      })
        .then(() => {
          if (this.$route.query.examId) {
            this.api.question
              .deleteExamQuestion({
                questionIdList: this.ids,
                examId: this.$route.query.examId
              })
              .then(result => {
                if (result.success) {
                  this.$message({
                    type: "success",
                    message: result.message
                  });
                  this.pageList();
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else if (this.$route.query.chapterId) {
            this.api.question
              .deleteChapterQuestion({
                questionIdList: this.ids,
                chapterId: this.$route.query.chapterId
              })
              .then(result => {
                if (result.success) {
                  this.$message({
                    type: "success",
                    message: result.message
                  });
                  this.pageList();
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
        })
        .catch(() => { });
    },
    reset () {
      this.row;
      if (this.$route.query.chapterId || this.$route.query.examId) {
        this.$refs.searchForm.resetFields();
      } else {
        // this.$refs.tree.setCheckedKeys([]);
        this.selectedVal_ = "";
        this.searchForm.courseIds = [];
        this.searchForm.courseId = '';
        this.$refs.searchForm.resetFields();
        let obj = {};
        obj.stopPropagation = () => { };
        try {
          this.$refs.tree.clearValue(obj);
        } catch (err) {
          this.$refs.tree.handleClear(obj);
        }
        this.page = {
          rows: [],
          total: 0,
          pageSize: 10,
          pageNumber: 1,
          sortName: "",
          sortOrder: ""
        };
        this.pageList();
      }

      // try {
      //   this.$refs.selectionTree.clearValue(obj);
      // } catch (err) {
      //   this.$refs.selectionTree.handleClear(obj);
      // }
    },
    handleCommand (command) {
      if (this.$route.query.chapterId) {
        this.$router.push({
          path: command,
          query: {
            chapterId: this.$route.query.chapterId
          }
        });
      } else if (this.$route.query.examId) {
        this.$router.push({
          path: command,
          query: {
            examId: this.$route.query.examId
          }
        });
      } else {
        this.$router.push({
          path: command
        });
      }
    },
    exportExcel () {
      this.loading = true;
      this.api.question
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },

  watch: {
    "searchForm.courseId" (val) {
      if (val) {
        this.getTree();
        this.searchForm.examId = "";
        this.searchForm.chapterId = "";
        this.searchForm.knowledgeId = "";
      } else {
        this.searchForm.examId = "";
        this.searchForm.chapterId = "";
        this.searchForm.knowledgeId = "";
        this.ChapterTree = [];
        this.ExamTree = [];
        this.KnowledgeTree = [];
      }
    },
    importFormVisible (val) {
      if (!val) {
        this.pageList();
      }
    },
    viewDetial (val) {
      if (!val) {
        this.viewForm = [];
      }
      console.log("this.viewForm", this.viewForm);
    },
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getQuestion();
      }
    }
  },
  mounted () {
    this.searchForm.courseId = this.courseId;
    this.pageList();
    this.getSubjectTreeList();
  }
};
</script>
<style lang="less" scoped>
p {
  font-size: 14px;
}
.view-content {
  .view-video {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;
    span {
      display: block;
      font-size: 14px;
      line-height: 30px;
    }
  }
  .view-one {
    width: 100%;
    display: flex;
    min-height: 50px;
    flex-direction: row;
    p {
      display: inline;
    }
    .optint-list {
      display: flex;
      flex-direction: column;
    }
    span {
      display: block;
      font-size: 14px;
      line-height: 30px;
    }
  }
  .view-two {
    height: 50px;
    display: flex;
    flex-direction: row;
    div {
      width: 50%;
      display: flex;
      flex-direction: row;
      align-items: center;
      span {
        display: block;
        font-size: 14px;
        line-height: 30px;
      }
    }
  }
}
.message {
  display: flex;
  flex-direction: row;
  .state {
    span {
      padding: 4px 8px;
      color: #fff;
      border-radius: 4px;
      margin-right: 10px;
    }
  }
  .questionTypeName {
    span {
      padding: 4px 8px;
      color: #fff;
      border-radius: 4px;
      margin-right: 10px;
    }
  }
  .htmltittle {
    white-space: nowrap;
    height: 23px;
    overflow: hidden;
    text-overflow: ellipsis;
    img {
      display: none !important;
    }
    p {
      font-size: 12px !important;
      margin: 0px !important;
      white-space: nowrap !important;
      color: #606266 !important;
      img {
        display: none !important;
      }
    }
  }
}
.top {
  width: 100%;
  display: flex;
  background: #fff;
  .top-item {
    width: 33.3%;
    margin-left: 10px;
    .item-lable {
      line-height: 30px;
      white-space: nowrap;
      font-size: 12px;
      color: rgb(162, 170, 188);
    }
    .item-value {
      white-space: nowrap;
      font-size: 18px;
      color: rgb(69, 90, 100);
      line-height: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/question.vue